var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"menus_wrap",attrs:{"text-color":"#333","default-active":_vm.$route.meta.id ? _vm.$route.meta.id.toString() : '',"active-text-color":"#4e70f2","unique-opened":true}},[_c('menu-item',{attrs:{"data":_vm.data,"editNameObj":_vm.editNameObj,"needCircleObj":_vm.waitCountObj},on:{"change":_vm.changes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }